<script setup>
import { ref, defineProps, defineEmits } from "vue";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import PuntoEncuentro from "@/page/PuntoEncuentro.vue";
import { useStorage } from "@/composables/useStorage";
import { useAppToast } from "@/composables/useAppToast";
import { useScreenStore } from "@/store/useScreenStore";

defineProps({
  visible: Boolean,
});
const emit = defineEmits(["update:visible"]);

const { saveConfig } = useStorage();
const toast = useAppToast();
const screen = useScreenStore();

const saving = ref(false);
const saved = ref(false);

const save = async () => {
  saving.value = true;
  try {
    await saveConfig(["puntoEncuentro"]);
  } catch (e) {
    console.error(e);
    toast.error("Ocurrió un error", "No se pudieron guardar los cambios.");
    saving.value = false;
    return;
  }
  saving.value = false;
  saved.value = true;
  setTimeout(() => (saved.value = false), 2500);
};
</script>

<template>
  <Dialog
    :visible="visible"
    @update:visible="(v) => emit('update:visible', v)"
    modal
    header="Puntos de Encuentro"
    :style="{ width: screen.isMobile ? '100%' : '700px' }"
  >
    <PuntoEncuentro />
    <template #footer>
      <Button label="Cerrar" text @click="emit('update:visible', false)" />
      <Button
        :label="saved ? 'Guardado' : 'Guardar'"
        :icon="saved ? 'pi pi-check' : 'pi pi-save'"
        :loading="saving"
        @click="save"
      />
    </template>
  </Dialog>
</template>
